import { Alert } from "@/components";
import { useModal } from "@/contexts";
import { createRandomString } from "@/utils";
import { Center } from "@chakra-ui/react";
import { useCheckInValue, useCheckOutValue, useSelectedRoomValue } from "@shared/client";
import { MEDIA } from "@styles/common";
import { useEffect } from "react";
import { CustomButton, CustomCenter, CustomText } from "./bookBar.style";
import { useBookParameter } from "./hooks";

export const BookBar = () => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const { openModal, setModalContent } = useModal();
    const { mutation, isLoading } = useBookParameter();
    const selectedRooms = useSelectedRoomValue();

    // 선택한 객체 배열 중 필요한 값들만 파싱
    const roomIdxGroup = selectedRooms.map((room) => room.roomIdx).join("|");
    const adultGroup = selectedRooms.map((room) => room.person?.adult).join("|");
    const childGroup = selectedRooms.map((room) => room.person?.child).join("|");
    const infantGroup = selectedRooms.map((room) => room.person?.infant).join("|");

    const finalBookPrice = selectedRooms.reduce((acc, cur) => acc + cur.newOffPrice, 0);
    const { isTablet, isMobile } = MEDIA();
    const TabletPaddingSize = isTablet ? "0 24px" : "0 24px";
    const handleBookStart = () => {
        if (checkOut) {
            const uid = createRandomString(6);
            const params = {
                uid,
                checkInDate: checkIn,
                checkOutDate: checkOut,
                roomIdx: roomIdxGroup,
                adult: adultGroup,
                child: childGroup,
                infant: infantGroup,
                section: "booking",
                page: "reserve",
            };

            mutation.mutate(params);
        }
    };

    useEffect(() => {
        if (isLoading) {
            setModalContent(<Alert>결제 페이지로 이동중 입니다...</Alert>);
            openModal();
        }
    }, [isLoading]);

    return (
        <CustomCenter position="sticky" bottom="0" w="100%">
            <Center
                w="100%"
                maxW="1600px"
                p={isMobile ? "0px" : TabletPaddingSize}
                m="0 auto"
                justifyContent="flex-end"
                columnGap={isMobile ? "8px" : "24px"}
                alignItems="center"
            >
                <CustomText>
                    총 <span>{Math.floor(finalBookPrice).toLocaleString()}</span>원
                </CustomText>
                <CustomButton size="medium" disabled={finalBookPrice === 0} onClick={handleBookStart}>
                    예약하기
                </CustomButton>
            </Center>
        </CustomCenter>
    );
};
